import React from "react";
import ButtonPagination from "../../pageInside/ButtonPagination";
import { elakayAutoText as text } from "../../pageInside/dataElakay";

// Buyer Previous/Next pagination (ButtonPagination) driven by a 1-based `page`.
export default function ProductPagination({ page, limit, total, onPage, infoSource }) {
  if (!total || total <= limit) return null;
  const skip = (page - 1) * limit;
  const shown = Math.min(limit, total - skip);
  return (
    <nav aria-label={text("h_pg_pages", "Pages")} className="ppag">
      <p className="ppag__info" role="status">{text("h_pg_range", "{value0}–{value1} of {value2}", { value0: skip + 1, value1: skip + shown, value2: total })}</p>
      <ButtonPagination size={shown} skip={skip} limit={limit} siseProduct={total} infoSource={infoSource} loadMore={() => onPage(page + 1)} loadMore0={() => onPage(page - 1)} />
    </nav>
  );
}
